import { LocationList } from 'components/Location/LocationList/LocationList'
import { AddLocationInput } from 'components/UserInputs'
import { useFormikContext } from 'formik'
import { useReadLocation } from 'hooks/locationHooks/useReadLocation'
import { Flex, Box } from 'theme-ui'
import { TeacherUpdateFormValues, ViewMode } from 'types'

export type TeachingLocationsFields = 'countryCode' | 'teachingLocations'

export type TeachingLocationsFormValues = Pick<
  TeacherUpdateFormValues,
  TeachingLocationsFields
>

export const TeachingLocationsSection = ({
  viewMode,
  switchToEditing,
}: {
  viewMode: ViewMode
  switchToEditing: () => void
  startTabIndex: number
}) => {
  const {
    values,
    setFieldValue,
  } = useFormikContext<TeachingLocationsFormValues>()
  const [readLocation] = useReadLocation()

  const addLocation = (id: string) => {
    setFieldValue('teachingLocations', [
      ...(values.teachingLocations ?? []),
      id,
    ])
    readLocation({ id })
  }
  const removeLocation = (removeId: string) => {
    if (values.teachingLocations) {
      setFieldValue(
        'teachingLocations',
        values.teachingLocations.filter((id) => id !== removeId)
      )
    }
  }
  return (
    <Flex variant={`forms.section.default`}>
      {viewMode === 'edit' || !values.teachingLocations?.length ? (
        <Box variant="forms.inputGroup.fullWidth">
          <AddLocationInput
            addLocation={addLocation}
            onClick={switchToEditing}
            hideDetails={viewMode === 'view'}
            currLocations={values.teachingLocations ?? []}
            countryCode={values.countryCode}
            tabIndex={50}
          />
        </Box>
      ) : null}
      <LocationList
        ids={values.teachingLocations}
        onRemoveLocation={removeLocation}
        viewMode={viewMode}
      />
    </Flex>
  )
}
